<form [formGroup]="form" class="flex flex-col items-start">
  <h3>{{"Address" | translate}}</h3>
  <mat-form-field class="w-full">
    <mat-label>{{"Company" | translate}}</mat-label>
    <input matInput placeholder="" formControlName="name" required />
    <button mat-icon-button class="undoButton" *ngIf="form.get('name')?.dirty && form.get('name')?.value != initialClient?.name" (click)="undoChanges('name', initialClient?.name); $event.stopPropagation()">
      <mat-icon>undo</mat-icon>
    </button>
    @if(form.get('name')?.invalid) {
    <mat-error>{{"dialog.companyError" | translate}}</mat-error>
    }
  </mat-form-field>
  <mat-form-field class="w-full">
    <mat-label>{{"Country"| translate}}</mat-label>
    <input matInput placeholder="" formControlName="country" />
    <button mat-icon-button class="undoButton" *ngIf="form.get('country')?.dirty && form.get('country')?.value != initialClient?.country" (click)="undoChanges('country', initialClient?.country); $event.stopPropagation()">
      <mat-icon>undo</mat-icon>
    </button>
    @if(form.get('country')?.invalid) {
    <mat-error>{{"dialog.countryError" | translate}}</mat-error>
    }
  </mat-form-field>
  <mat-form-field class="w-full">
    <mat-label>{{"City" | translate}}</mat-label>
    <input matInput placeholder="" formControlName="city" />
    <button mat-icon-button class="undoButton" *ngIf="form.get('city')?.dirty && form.get('city')?.value != initialClient?.city" (click)="undoChanges('city', initialClient?.city); $event.stopPropagation()">
      <mat-icon>undo</mat-icon>
    </button>
    @if(form.get('city')?.invalid) {
    <mat-error>{{"dialog.cityError" | translate}}</mat-error>
    }
  </mat-form-field>
  <mat-form-field class="w-full">
    <mat-label>{{"ZIP" | translate}}</mat-label>
    <input matInput placeholder="" formControlName="zipcode" />
    <button mat-icon-button class="undoButton" *ngIf="form.get('zipcode')?.dirty && form.get('zipcode')?.value != initialClient?.zipcode" (click)="undoChanges('zipcode', initialClient?.zipcode); $event.stopPropagation()">
      <mat-icon>undo</mat-icon>
    </button>
    @if(form.get('zipcode')?.invalid) {
    <mat-error>{{"dialog.zipError" | translate}}</mat-error>
    }
  </mat-form-field>
  <mat-form-field class="w-full">
    <mat-label>{{"Street" | translate}}</mat-label>
    <input matInput placeholder="" formControlName="street" />
    <button mat-icon-button class="undoButton" *ngIf="form.get('street')?.dirty && form.get('street')?.value != initialClient?.street" (click)="undoChanges('street', initialClient?.street); $event.stopPropagation()">
      <mat-icon>undo</mat-icon>
    </button>
    @if(form.get('street')?.invalid) {
    <mat-error>{{"dialog.streetError" | translate}}</mat-error>
    }
  </mat-form-field>
  @if(initialClient?.customerNumber) {
  <mat-form-field class="w-full">
    <mat-label>{{ "customerNumber" | translate }}</mat-label>
    <input matInput [value]="initialClient?.customerNumber" readonly />
  </mat-form-field>
  }
</form>
